// Model.js
// -----------------------
// @module Case
define("BluePoint.WebinarForm.WebinarForm.SS2Model", ["Backbone", "Utils"], function(
    Backbone,
    Utils
) {
    "use strict";

    // @class Case.Fields.Model @extends Backbone.Model
    return Backbone.Model.extend({
        //@property {String} urlRoot
        urlRoot: Utils.getAbsoluteUrl(
            getExtensionAssetsPath(
                "Modules/WebinarForm/SuiteScript2/WebinarForm.Service.ss"
            ),
            true
        )
    });
});
